import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import HeaderComponent from './components/HeaderComponent.vue'
import About from './components/About.vue'
import Team from './components/Team'
import Services from './components/Services'
import Portfolio from './components/Portfolio'
import Customers from './components/Customers'
import Contact from './components/Contact'
import FooterComponent from './components/FooterComponent'
import Project from './components/Project.vue'
import PageMar from './components/MarbyMarabunta/PageMar.vue'
import PageNotFound from './components/Component404.vue'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes = [
	{
		path: '/proyecto',
		name: 'project', 
		component: Project,
		meta: { scrollToTop: true }
	},
	{
		path: '/', 
		name: 'index',
		components: {
			a: HeaderComponent,
			b: About,
			c: Team,
			d: Services,
			e: Portfolio,
			f: Customers,
			g: Contact,
			h: FooterComponent
		}
	},
	{
		path: '/marbymarabunta',
		name: 'marbymarabunt',
		component: PageMar,
	},
	{
		path: '*',
		name: 'PageNotFound',
		redirect: '/404'
	},
	{ 
		path: '/404', 
		component: PageNotFound 
	},
];

const router = new VueRouter({
	mode: 'history',
	routes,
	base: '/',	
	scrollBehavior: function(to) { 
		if (to.hash) { 
			return {selector: to.hash} 
		} else { return { x: 0, y: 0 } } 
	}, 
	// scrollBehavior (to, from, savedPosition) {
	// 	if(savedPosition){
	// 		return savedPosition
	// 	}else{
	// 		const position = {}

	// 		if (to.hash) {
	// 			return{
	// 				selector: to.hash
	// 			}
	// 		}

	// 		return new Promise(resolve => {
	// 			if (to.matched.some(m => m.meta.scrollToTop)) {
	// 				// coords will be used if no selector is provided,
	// 				// or if the selector didn't match any element.
	// 				position.x = 0
	// 				position.y = 0
	// 			}
	// 			resolve(position)
	// 		})
	// 	}
	// }
  });

export default router;